// extracted by mini-css-extract-plugin
module.exports = {"OSDToolbar":"dH2","icon":"dH3","withSpacer":"dH4","roundedUp":"dH5"};